module.exports = __webpack_public_path__ + "media/kr_web_25w.a9c2768a.mp4";